import React from 'react';
import { Link } from 'react-router-dom';
import { usePodcastPlayer } from '../../context/PodcastPlayerContext';
import Media from '../../components/common/Media';
import { styled, css } from '../../stitches.config';
import { IPodcastSerie } from '../../stores/PodcastStore';
import { h3, bodyLarge } from '../commonStyles/Fonts';
import Balls from '../components/Balls';
import { IPodcast } from '../types/Podcast';

const PodcastSeriesBox: React.FC<IPodcastSerie> = ({ title, poster, url, author, lead, label, latest }) => {

    const { setEpisode } = usePodcastPlayer();

    return (
        <Podcast withLead={!!label}>
            <Link to={url}>
                <Wrapper>
                    {label && <SeriesLabel>
                        <Balls />{label}
                    </SeriesLabel>}
                    <SeriesPoster>
                        <PosterWrapper>
                            <Media
                                media={poster.media}
                                src={poster.img}
                                alt={title}
                                height={350}
                                width={350}
                                aspectRatio={1}
                                preserveRatio={true}
                            />
                        </PosterWrapper>
                    </SeriesPoster>
                    <SeriesDescription>
                        <Text className={h3()}>
                            {title}
                        </Text>
                        <Text style={{ color: '#8D8D8D' }}>
                            {author.toString()}
                        </Text>
                        <PodcastLead className={bodyLarge()}>
                            {lead}
                        </PodcastLead>
                        {latest && <Link to={url} className={`${bodyLarge()} ${Button()}`} onClick={() => { if (latest) setEpisode(latest) }}>
                            Słuchaj
                        </Link>}
                    </SeriesDescription>
                </Wrapper>
            </Link>
        </Podcast>
    );
};

export default PodcastSeriesBox;

const SeriesPoster = styled('div', {
    position: 'relative',
    paddingTop: '100%',
    background: '$grayscale25',
    transition: 'all 0.2s',
    overflow: 'hidden',
});

const PosterWrapper = styled('div', {
    position: 'absolute',
    inset: 0,
    'img': {
        objectPosition: 'center',
        objectFit: 'cover',
        width: '100%',
        height: '100%'
    }
});

const SeriesDescription = styled('div', {
    position: 'relative',
    zIndex: 3,
    padding: '2.4rem',
    background: '$grayscale0Fixed',
    transition: 'all 0.5s',
    display: 'flex',
    flexFlow: 'column',
    height: '100%'
});

const PodcastLead = styled('p', {
    margin: 'auto 0 0.5rem',
    transform: 'translateY(5rem)',
    transition: 'all 0.3s',
    fontWeight: 700,
    letterSpacing: '0.2px'
});

const Podcast = styled('div', {
    background: 'white',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
        content: '',
        display: 'block',
        paddingTop: '142.682%',
        '@bp4': {
            paddingTop: '146.66666%'
        }
    },
    '&:hover': {
        [`${SeriesDescription}`]: {
            marginTop: '-100%',

        },
        [`${PodcastLead}`]: {
            marginTop: 0,
            transform: 'translateY(0)'
        }
    },
    variants: {
        withLead: {
            true: {
                '&:hover': {
                    [`${SeriesDescription}`]: {
                        paddingTop: '6.5rem'
                    }
                }
            }
        }
    }
});

const Wrapper = styled('div', {
    position: 'absolute',
    color: '$grayscale100Fixed',
    inset: 0
});

const SeriesLabel = styled('div', {
    position: 'absolute',
    top: '2.4rem',
    left: '2.4rem',
    zIndex: 1,
    background: '$primary',
    textTransform: 'uppercase',
    fontWeight: 800,
    lineHeight: '1.6rem',
    fontSize: '1.2rem',
    padding: '0.4rem 0.8rem 0.4rem 1.6rem',
    color: '$grayscale0Fixed',
    letterSpacing: '0.8px'
});

const Text = styled('p', {
    margin: '0 0 0.25em',
    fontWeight: '600'
});

const Button = css({
    background: '$primary',
    padding: '1.25rem 2rem',
    marginTop: 'auto',
    marginRight: 'auto',
    '&:hover': {
        color: '$grayscale0Fixed',
    }
});